module.exports = __webpack_public_path__ + "static/img/swiperImg1.68a65fe0.png";